import { render, staticRenderFns } from "./ylPayConfirm.vue?vue&type=template&id=5268ec60&scoped=true&"
import script from "./ylPayConfirm.vue?vue&type=script&lang=js&"
export * from "./ylPayConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ylPayConfirm.vue?vue&type=style&index=0&id=5268ec60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5268ec60",
  null
  
)

export default component.exports